<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="data.form.unidades"
                    :validations="validations.unidade"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="form.unidadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :disabled="!form.unidadeId"
                    :options="infraestruturas"
                    :validations="validations.infraestrutura"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="form.infraestruturaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input-autocomplete
                    :disabled="!form.infraestruturaId"
                    :repository="repositories.usuario"
                    :request-query-string-params="autocompleteParams.usuario"
                    :search-fields="fields.autocompletes.usuario"
                    :validations="validations.usuario"
                    label="Profissional"
                    text-field="cidadaoNome"
                    v-model="form.usuario"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :disabled="!form.usuario"
                    :options="form.ocupacoes"
                    :validations="validations.ocupacao"
                    label="CBO"
                    show-default-option
                    text-field="descricao"
                    v-model="model.lotacaoId"
                    value-field="lotacaoId"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, error, object } from '@/mixins'

import { mapActions } from 'vuex'

export default {
    computed: {
        autocompleteParams() {

            return {
                usuario: {
                    infraestrutura_id: this.form.infraestruturaId
                }
            }
        },
        fields() {

            return {
                autocompletes: {
                    usuario: [
                        { key: 'cadastro_cidadao.nome', searchable: true },
                    ]
                }
            }
        },
        validations() {

            return {
                usuario: { required: true },
                unidade: { required: true },
                infraestrutura: { required: true },
                ocupacao: { required: true },
            }
        },
        infraestruturas() {

            if (this.form.unidadeId) {

                return this.data.form.unidades.find(u => u.id === this.form.unidadeId).infraestruturas
            }

            return []
        }
    },
    created() {

        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            parametrizacao: this.getConectaSusRepository('prontoAtendimento.parametrizacao'),
        }
    },
    data: () => ({
        form: {
            ocupacoes: [],
            unidadeId: null,
            infraestruturaId: null,
            usuario: null,
        },
        model: {
            lotacaoId: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.isDuplicated()) {

                        this.showValidationNotification(
                            'Este profissional com a mesma CBO já foi incluído para este local de atendimento.'
                        )

                        return
                    }

                    const unidade = this.data.form.unidades.find(u => u.id === this.form.unidadeId)
                    const infraestrutura = this.infraestruturas.find(i => i.id === this.form.infraestruturaId)
                    const ocupacao = this.form.ocupacoes.find(o => o.lotacaoId === this.model.lotacaoId)

                    const data = {
                        lotacaoId: ocupacao.lotacaoId,
                        usuarioNome: this.form.usuario.cidadaoNome,
                        unidadeNomeFantasia: unidade.nomeFantasia,
                        infraestruturaNome: infraestrutura.nome,
                        ocupacaoDescricao: ocupacao.descricao
                    }

                    this.data.model.lotacoesExameLaboratorial.push(data)

                    this.$emit('save', this.clone(data))
                })
        },
        isDuplicated() {

            return this.data.model.lotacoesExameLaboratorial
                .find(p => p.lotacaoId === this.model.lotacaoId)
        }
    },
    mixins: [repository, error, object],
    props: {
        data: { type: Object, required: true },
    },
    watch: {
        'form.unidadeId': function () {

            this.form.infraestruturaId = null
        },
        'form.infraestruturaId': function () {

            this.form.usuario = null
        },
        'form.usuario': function (usuario) {

            this.model.lotacaoId = null

            if (usuario) {

                this.setLoading()

                this.repositories.parametrizacao.getOcupacoes(this.form.infraestruturaId, usuario.id)
                    .then(({ data }) => this.form.ocupacoes = data)
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        }
    }
}
</script>
